import { BaseService } from "./BaseService";

export class DepartmentsService extends BaseService {
  constructor() {
    super("departments");
  }
}